import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { ClvrScreenControlDataTypeDto } from '../Types/ClvrScreenControlDataTypeDto'
import { ScreenControlDataTypeData } from '../Types/ScreenControlDataTypeData'
import { get } from 'lodash'

export class ClvrScreenControlDataTypeApiAdapter implements ApiDataAdapter<ScreenControlDataTypeData> {
    public createClass(apiData: ClvrScreenControlDataTypeDto): ScreenControlDataTypeData {
        const dataTypes = get(apiData, '_dataTypeChildren', [])

        return {
            id: get(apiData, 'id'),
            name: get(apiData, 'name'),
            parentDataTypeId: get(apiData, 'parentDataTypeId') || null,
            rank: get(apiData, 'rank') || 0,
            enable: get(apiData, 'isVisible', false),
            creationDate: get(apiData, 'creation_date'),
            updateDate: get(apiData, 'update_date'),
            dataTypeChildren: dataTypes.map(new ClvrScreenControlDataTypeApiAdapter().createClass),
        }
    }
}
